import React from "react";

// 로그인 유도 모달 — 디자인 시스템 sc-modal
const LoginRequiredModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="sc-modal-backdrop" onClick={onClose}>
            <div className="sc-modal" onClick={(e) => e.stopPropagation()}>
                <div className="sc-modal__head">
                    <div className="sc-modal__title">로그인이 필요합니다</div>
                    <button type="button" className="sc-modal__x" onClick={onClose} aria-label="닫기">✕</button>
                </div>
                <div className="sc-modal__body">해당 메뉴를 사용하려면 로그인해야 합니다.</div>
                <div className="sc-modal__foot">
                    <button type="button" className="sc-btn sc-btn--ghost" onClick={onClose}>취소</button>
                    <button type="button" className="sc-btn" onClick={onConfirm}>로그인</button>
                </div>
            </div>
        </div>
    );
};

export default LoginRequiredModal;
